import { HEADER_SECTIONS, HEADER_SUB_MENU_SECTIONS } from "@/constants/Header";
import { getCookie } from "@/helpers/cookies";

export default {
  computed: {
    sections() {
      return HEADER_SECTIONS;
    },
    subMenuSections() {
      return HEADER_SUB_MENU_SECTIONS;
    },
    profile() {
      const portalUsername = getCookie("PORTAL_USER_NAME");
      if (!portalUsername || portalUsername.length === 0) {
        return "U";
      }
      const firstLetter = portalUsername[0];
      const plusIndex = portalUsername.indexOf('+');
      const lastLetter = plusIndex !== -1 && plusIndex + 1 < portalUsername.length ? portalUsername[plusIndex + 1] : firstLetter;
      return `${firstLetter + lastLetter}`.toUpperCase();
    },
    profileDesktop() {
      const portalUsername = getCookie("PORTAL_USER_NAME");
      if (!portalUsername || portalUsername.length === 0) {
        return "User";
      }
      const firstLetter = portalUsername[0];
      const namePart = portalUsername.split('+')[0];
      if (namePart.length <= 1) {
        return firstLetter.toUpperCase();
      }
      return `${firstLetter}`.toUpperCase() + namePart.substring(1).toLowerCase();
    }
  },
};
